import { LayoutFetchResponse } from '@lastbrand/storefront-proto-registry/api/v1/layoutfetch'
import { FilterSortWidgetData, ProductCardData, WidgetChild } from '@lastbrand/storefront-proto-registry/api/v1/widget'

import { isFeedDynamic, VariantList } from '@src/pages/[...slug]/components/collection/collection.helpers'
import {
  Filter,
  FilterConfig,
  FilterOptions,
} from '@src/pages/[...slug]/components/collection/domains/CollectionFilter'
import { getFormattedSlug } from '@src/pages/[...slug]/components/collection/utils'
import { PRODUCT_TYPES } from '@src/quince-site-common/src/domains/Product/BundleProduct'
import { ProductOptionDisplayType } from '@src/quince-site-common/src/domains/ProductOption'
import filterFalsy from '@src/quince-site-common/src/utils/filterFalsy'

import type { Widget } from '@lastbrand/storefront-proto-registry/api/v1/layoutfetch'

const getVariantsListFromCollection = (productListData: WidgetChild[]): VariantList[] => {
  const variantList: VariantList[] = []
  let index = 0

  variantList.push(
    ...filterFalsy(
      productListData.map((child: WidgetChild) => {
        const productCardData: ProductCardData | undefined = child.data?.productItem
        if (!productCardData) {
          return null
        }

        if ('type' in productCardData && String(productCardData.type) === String(PRODUCT_TYPES.BUNDLE)) {
          return null
        }
        const variant1 = productCardData.cardVariants[0]
        const price = variant1?.price?.salePrice
        if (!productCardData.relatedIds?.spid) {
          return false
        }
        return {
          product_id: Number(productCardData.relatedIds.spid),
          price: `$${price ?? ''}`,
          // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
          labels: productCardData.title || '',
          variant_id: Number(variant1?.svids[0] ?? 0),
          index: index++,
        }
      }),
    ),
  )

  return variantList
}

const getFilterList = (filters: FilterSortWidgetData['filters'] | undefined): Filter[] | undefined => {
  if (!filters?.options) {
    return undefined
  }
  return filters.options.map(filter => {
    return new Filter({
      name: filter.id,
      config: new FilterConfig({
        columnsToShow: 2,
        label: filter.displayName.toUpperCase(),
        type: filter.type as unknown as string,
      }),
      values: filter.options.map(
        option =>
          new FilterOptions({
            name: option.id,
            value: option.id,
            displayName: option.displayName,
            imgURL: option.image?.url ?? '',
            displayType: ProductOptionDisplayType.COLOR,
          }),
      ),
    })
  })
}

type WidgetMap = Record<string, Widget>

export const getCollectionViewData = (
  plData: LayoutFetchResponse,
  { zipCode }: { zipCode: string | null | undefined },
) => {
  const widgetObj = plData.widgets.reduce<WidgetMap>((acc, curr) => {
    return {
      ...acc,
      [curr.type]: curr,
    }
  }, {})
  const filterWidget = widgetObj.FILTER_AND_SORT
  const filterSortData = (filterWidget?.data as { filterSortData?: FilterSortWidgetData } | undefined)?.filterSortData
  const filters = filterSortData?.filters
  const productListWidget = widgetObj.PRODUCT_LIST
  const productListData = (productListWidget?.children ?? []) as unknown as WidgetChild[]

  const filterList = getFilterList(filters)

  return {
    collection_id: plData.analytics?.collectionId ?? '',
    collection_name: plData.meta?.title,
    collectionSlug: getFormattedSlug(plData.meta?.slug ?? ''),
    variantList: getVariantsListFromCollection(productListData),
    filterList,
    zipCode: zipCode,
    isDynamicCollectionPage: isFeedDynamic(plData.meta?.slug ?? ''),
    // sort_model: collectionPage.subcollectionSortingType,  need support for this
  }
}
